// extracted by mini-css-extract-plugin
export default {"PrivacyPolicyPage":"PrivacyPolicyPage_PrivacyPolicyPage__Hxwci"};